import React, { useContext } from 'react';
import { Badge } from 'module-tsl-ui-elements';
import { JobContext } from '../JobContext';
export var JobFlags = function JobFlags(_ref) {
  var size = _ref.size;

  var _useContext = useContext(JobContext),
      flag = _useContext.flag,
      quickApplication = _useContext.quickApplication,
      prefix = _useContext.prefix;

  if (!flag) return null;
  var isNew = flag.isNew,
      isExpiring = flag.isExpiring,
      isClosed = flag.isClosed,
      isRecentlyExpired = flag.isRecentlyExpired,
      isEarlyApplicantFlag = flag.isEarlyApplicantFlag,
      label = flag.label;
  var hasEnded = isClosed || isRecentlyExpired;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "__content__badges")
  }, quickApplication && /*#__PURE__*/React.createElement(Badge, {
    size: size,
    theme: "pacific-blue"
  }, "Quick Apply"), isEarlyApplicantFlag && /*#__PURE__*/React.createElement(Badge, {
    size: size,
    theme: "forest-green"
  }, "Be an early applicant"), hasEnded && /*#__PURE__*/React.createElement(Badge, {
    size: size,
    theme: "k-25"
  }, label), isNew && /*#__PURE__*/React.createElement(Badge, {
    size: size,
    theme: "forest-green"
  }, label), isExpiring && /*#__PURE__*/React.createElement(Badge, {
    size: size,
    theme: "red-ribbon"
  }, label));
};
JobFlags.displayName = "JobFlags";